

import coreHandlerInit from "./modules/core-handler";
import scrollTopInit from "./modules/scroll-top";
import thumbItemInit from "./modules/thumb-item";
import checkExternalLinks from "./modules/checkExternalLinks";
import "./scss/style.scss";

scrollTopInit();
coreHandlerInit();
// wpPostInit();
thumbItemInit();

checkExternalLinks();